import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from 'react-date-picker';
import { Container, Button, Row, Form, Card, Col, FloatingLabel } from "react-bootstrap";

import RTable from "./Table"
import { loadAllPo, loadPo, resetPo } from "../action/poAction";


import { dangerNotification, notification, warningNotification } from "../action/notificationAction";
import { Typeahead } from "react-bootstrap-typeahead"
import { format, subDays } from "date-fns";
import {
  setEnableMobileMenu
} from '../constant/constant';
import { formatCurrency } from "../constant/format";
import { filterClient, filterClientsSearch, filterProjects, filterProjectsSearch, filterVendorsSearch } from "../constant/filterTypeahead";
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import { pAxios } from "..";
import fileDownload from "js-file-download";


export default function PoDocx({ minDate, permitted }) {

  const dispatch = useDispatch();

  const cltTypeRef = React.useRef(null);
  const proTypeRef = React.useRef(null);
  const venTypeRef = React.useRef(null);


  const [status, setStatus] = useState("active");
  const [show, setShow] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [startDate, setStartDate] = useState(minDate ? new Date(minDate) : subDays(new Date(), 7));
  const [endDate, setEndDate] = useState(new Date());
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [selectedClientId, setSelectedClientId] = useState(null);
  const [selectedVendorId, setSelectedVendorId] = useState(null);
  const [selectedSide, setSelectedSide] = useState("Client");

  React.useEffect(() => {

    dispatch(resetPo())


    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {

    setStatus("active");
    setShow(false);
    dispatch(resetPo())
    setSelectedClientId(null);
    setSelectedProjectId(null);
    setSelectedVendorId(null);
    setStartDate(minDate ? new Date(minDate) : subDays(new Date(), 7));
    setEndDate(new Date());


    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSide]);

  const pos = useSelector(
    (state) => state.po.pos
  );

  const clients = useSelector(
    (state) => state.lookup.client
  );

  const projects = useSelector(
    (state) => state.lookup.project
  );

  const vendors = useSelector(
    (state) => state.lookup.vendor
  );

  const costcenter = useSelector(
    (state) => state.costcenter.costcenter
  );


  const handleClose = (skipLoad) => {
    setShow(false);
    dispatch(resetPo());

  }



  const downloadPo = (id, name) => {
    pAxios({
      "method": "GET",
      "url": "/api/auth",

    }).then(r => {

      pAxios.get(`/api/docx/${id}`, {
        responseType: 'blob',
      })
        .then((res) => {
          fileDownload(res.data, `PurchaseOrder.pdf`)
        }).catch((err)=>{
              dispatch(dangerNotification("Failed to download purchase order"));
        });
    })
  }

  const columns = React.useMemo(
    () => [
      {
        Header: 'Id',
        accessor: 'id'
      },
      {
        Header: 'Project',
        accessor: 'projectname',
        className: 'w-100p'
      },
      {
        Header: 'Name',
        accessor: (cell) => cell['vendorname'] ?? cell['clientname'],
        className: 'w-100p',
        textFilter: true
      },
      {
        Header: 'Type',
        accessor: 'type',
      },
      {
        Header: 'Date',
        accessor: (cell) => cell['date'] ? format(new Date(cell['date']), "dd-MM-yyyy") : "",
      },
      {
        Header: 'Number',
        accessor: 'number',
        textFilter: true
      }, {
        Header: 'Gross',
        accessor: (cell) => formatCurrency(cell['gross']),
        className: 'text-end',
        hideFilter: true
      }, {
        Header: 'Closed',
        id: 'closedDate',
        accessor: (cell) => cell['closedDate'] ? format(new Date(cell['closedDate']), "dd-MM-yyyy") : "",
        show: status === 'active'
      }, {
        Header: 'Action',
        id: 'action',
        hideFilter: true,
        accessor: (cell) => {
          return <React.Fragment>
            <div className="text-center">

              <Button size="sm" variant="outline-success" className="pt-0 pb-0 me-2" title="Download Po Document"
                onClick={() => { downloadPo(cell['id'], cell['name'] )}}>
                <i class="fa fa-download" role="button"></i></Button>
            </div>
          </React.Fragment>
        }
      }],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [status, selectedSide]
  )


  const onChange = (dates) => {

    if (dates && dates.length > 0) {

      const [start, end] = dates;
      setStartDate(start);
      setEndDate(end);
    }
    else {
      setStartDate(null);
      setEndDate(null);

    }
  };


  const search = (e) => {

    let filter = null;
    if (selectedSide === 'Client' && selectedClientId) {
      filter = selectedClientId;
    }
    else if (selectedSide === 'Vendor' && selectedVendorId !== null) {
      filter = selectedVendorId;
    }

    // if (filter) {

    if (selectedProjectId) {
      dispatch(loadAllPo(status, selectedSide, filter, selectedProjectId, startDate ? format(startDate, "yyyy-MM-dd") : null, endDate ? format(endDate, "yyyy-MM-dd") : null, costcenter, "Y"));
    }


    else if (filter != null) {
      dispatch(loadAllPo(status, selectedSide, filter, null, startDate ? format(startDate, "yyyy-MM-dd") : null, endDate ? format(endDate, "yyyy-MM-dd") : null, costcenter, "Y"));
    }

    else if (startDate && endDate) {
      dispatch(loadAllPo(status, selectedSide, null, null, startDate ? format(startDate, "yyyy-MM-dd") : null, endDate ? format(endDate, "yyyy-MM-dd") : null, costcenter, "Y"));
    }

    // }
    else if (e) {
      dispatch(warningNotification(`Select a valid ${selectedSide} or project to load po's`))
    }

  }



  React.useEffect(() => {

    search();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, status, selectedSide, costcenter]);

  React.useEffect(() => {
    dispatch(setEnableMobileMenu(false));
  }, [dispatch]);


  React.useEffect(() => {

    setSelectedClientId(null);
    setSelectedProjectId(null);
    handleClose(true);
    cltTypeRef?.current?.clear();
    proTypeRef?.current?.clear();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [costcenter]);


  const theme = useSelector((state) => state.ThemeOptions);


  return (
    <React.Fragment>
      <Container fluid className={`${show ? 'd-none' : ''}`}>
        <Card >
          <Card.Header className={`${theme.headerBackgroundColor} d-flex`}>
            <h6 className="text-start flex-fill fw-bold"> {selectedSide} Purchase Order</h6>

          </Card.Header>
          <Card.Body>
            <Row className="mb-3 g-2">
              <Col sm={12} md={3}>
                <div style={{ position: "relative" }} className="dp">
                  <DateRangePicker maxDate={new Date()} id="poDateRangeFilter"

                    format="dd-MM-yyyy"
                    onChange={onChange}
                    value={[startDate, endDate]}
                    calendarIcon={<i className="fa fa-calendar"></i>}
                    // clearIcon = {null}
                    className="form-control"
                    isClearable={true}
                  ></DateRangePicker>
                  <label className="black-text" htmlFor="poDateRangeFilter">Purchase Order Date</label>
                </div>
              </Col>

              <Col sm={12} md={3} >
                <FloatingLabel controlId="floatingSide" label={`Select Client/Vendor`}>
                  <Form.Select
                    value={selectedSide}
                    onChange={e => {
                      setSelectedSide(e.target.value)

                    }}
                  >
                    <option value="0"> Select side</option>
                    <option value="Client">Client</option>
                    <option value="Vendor">Vendor</option>


                  </Form.Select>
                </FloatingLabel>
              </Col>

              {
                selectedSide === 'Client' ? (
                  <Col sm={12} md={3} >


                    <Typeahead
                      id="floating-label-clt-filter"
                      onChange={(e) => {
                        setSelectedClientId(e[0]?.id)
                      }}
                      clearButton
                      onBlur={() => {
                        if (!selectedClientId) {
                          cltTypeRef.current?.clear();
                          proTypeRef.current?.clear();
                          setSelectedProjectId(null)
                        }
                      }}
                      labelKey="name"
                      options={filterClientsSearch(clients, costcenter)}
                      ref={cltTypeRef}
                      placeholder="Choose A Client"
                      renderInput={({ inputRef, referenceElementRef, ...inputProps }) => {
                        return (

                          <FloatingLabel controlId="floatingClientFilter" label="Select A Client">
                            <Form.Control
                              {...inputProps}
                              ref={(node) => {
                                inputRef(node);
                                referenceElementRef(node);
                              }}
                            />
                          </FloatingLabel>

                        );
                      }}
                      selected={selectedClientId ? clients.filter(e => e.id === selectedClientId) : []}
                    />


                  </Col>
                ) : <Col sm={12} md={3} >
                  <Typeahead
                    id="floating-label-ven-filter"
                    onChange={(e) => {
                      setSelectedVendorId(e[0]?.id)
                    }}
                    clearButton
                    onBlur={() => {
                      if (selectedVendorId === null) {
                        venTypeRef.current?.clear();
                      }
                    }}
                    labelKey="name"
                    options={filterVendorsSearch(vendors)}
                    ref={venTypeRef}
                    placeholder="Choose A Vendor"
                    renderInput={({ inputRef, referenceElementRef, ...inputProps }) => {
                      return (

                        <FloatingLabel controlId="floatingVendorIdFilter" label="Select A Vendor">
                          <Form.Control
                            {...inputProps}
                            ref={(node) => {
                              inputRef(node);
                              referenceElementRef(node);
                            }}
                          />
                        </FloatingLabel>

                      );
                    }}
                    selected={selectedVendorId !== null ? vendors.filter(e => e.id === selectedVendorId) : []}
                  />

                </Col>
              }

              <Col sm={12} md={3} >


                <Typeahead
                  id="floating-label-pro-filter"
                  onChange={(e) => {
                    setSelectedProjectId(e[0]?.id)
                  }}
                  clearButton
                  labelKey="name"
                  onBlur={() => {
                    if (!selectedProjectId) {
                      proTypeRef.current?.clear();
                    }
                  }}
                  options={projects && ((selectedClientId && selectedClientId !== "0") || selectedSide === "Vendor") ?
                    filterProjectsSearch(projects, costcenter).filter(e => Number(e.clientid) === Number(selectedClientId) || selectedSide === "Vendor") : []}

                  ref={proTypeRef}
                  placeholder="Choose A Project"
                  renderInput={({ inputRef, referenceElementRef, ...inputProps }) => {
                    return (

                      <FloatingLabel controlId="floatingProjectFilter" label="Select A Project">
                        <Form.Control
                          {...inputProps}
                          ref={(node) => {
                            inputRef(node);
                            referenceElementRef(node);
                          }}
                        />
                      </FloatingLabel>

                    );
                  }}
                  selected={selectedProjectId ? projects.filter(e => e.id === selectedProjectId) : []}
                />


              </Col>
              <Col >
                {
                  !show ? (<div className="d-grid flex-fill d-md-flex gap-2  justify-content-md-end  h-100 align-items-end">

                    <Button variant="primary" size="sm" onClick={() => search('e')}>Search</Button>
                  </div>) : ""}
              </Col>
            </Row>
          </Card.Body>
        </Card>
        <RTable columns={columns} data={pos} title="Purchase Orders" status={status} changeStatus={setStatus} hideColumn={status === 'active' ? ['closedDate'] : ['action']}> </RTable>
      </Container>

    </React.Fragment >);
}

// }
